import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';
import {REmployees, Role, Roles} from './types';

const initialState: Roles = {
    items: [],
    offset: 0,
    total: 0,
    canShowAndEditEmployees: false,
    canShowAndEditPermissions: false,
}

const upsertRole = (state: Roles, role: Role) => {
    const index = state.items.findIndex((item) => item.id === role.id);

    if (index !== -1) {
        state.items[index] = role;
        return;
    }

    state.items.push(role);
    state.total += 1;
}

export const getRoles = createAsyncThunk(
    'roles/get',
    async (page: number) => {
        const response = await HttpClient.roleApi.getRoles<Roles>(page);
        return response.data
    }
)

export const addRole = createAsyncThunk(
    'roles/create',
    async (role: Role) => {
        const response = await HttpClient.roleApi.add<Role>(role);
        return response.data
    }
)

export const updateRole = createAsyncThunk(
    'roles/update',
    async (role: Role) => {
        const response = await HttpClient.roleApi.update<Role>(role);
        return response.data
    }
)

export const deleteRole = createAsyncThunk(
    'roles/delete',
    async (id: number) => {
        const response = await HttpClient.roleApi.delete<Role>(id);
        return response.data
    }
)

const typeSplice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        clearRoles: (state) => {
            return initialState
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRoles.fulfilled, (state, action) => {
            if (action.payload.offset === 0) {
                return action.payload
            } else {
                state.items = [...state.items, ...action.payload.items];
                state.offset = action.payload.offset;
            }
        });
        builder.addCase(addRole.fulfilled, (state, action) => {
            upsertRole(state, action.payload);
        });
        builder.addCase(updateRole.fulfilled, (state, action) => {
            upsertRole(state, action.payload);
        });
        builder.addCase(deleteRole.fulfilled, (state, action) => {
            const nextItems = state.items.filter((item) => item.id !== action.meta.arg);
            if (nextItems.length !== state.items.length) {
                state.items = nextItems;
                state.total = Math.max(0, state.total - 1);
            }
        });
    }
})

export const { clearRoles } = typeSplice.actions

export default typeSplice.reducer;
